import { PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import { getActiveApp, getActiveView } from "src/redux/selectors/app";
import logo from "../../images/logo.png";
import ProfileV2 from "./ProfileV2";

const HeaderLayout = ({ children }: PropsWithChildren) => {
  const activeView = useSelector(getActiveView);
  const activeApp = useSelector(getActiveApp);
  return (
    <div className="grid h-auto">
      <div className="sticky top-0 z-40 lg:mx-auto lg:px-8 h-[94px] flex w-full items-center bg-white">
        <div className="flex h-16 items-center gap-x-4 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-0 lg:shadow-none w-full">
          <div className="flex h-16 shrink-0 items-center justify-center mt-32px mb-44px">
            <img className="h-54px w-auto" src={logo} alt="Annex Crm Logo" />
          </div>

          <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6 w-full justify-end items-center">
            {/* <SearchText /> */}

            <div className="flex items-center gap-x-4 lg:gap-x-8">
              <ProfileV2 />
            </div>
          </div>
        </div>
      </div>
      <main
        className="flex py-[32px] bg-white-ghost h-full min-h-full"
        style={{ minHeight: "calc(100vh - 94px)" }}
      >
        <div className="flex px-4 sm:px-6 lg:px-8 min-h-full w-full">
          {children}
        </div>
      </main>
    </div>
  );
};

export default HeaderLayout;
